import { defineComponent, ref, watch } from '@vue/composition-api';
import Icon from 'src/components/Icon.vue';
import { BfTextInput } from 'components/Butterfly';
const SliceRename = defineComponent({
    components: {
        Icon,
        BfTextInput,
    },
    props: {
        initialValue: { type: String, required: true },
        submit: { type: Function, required: true },
    },
    setup(props) {
        const value = ref('');
        const editMode = ref(false);
        watch(() => props.initialValue, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                value.value = newVal;
            }
        }, {
            immediate: true,
        });
        const save = () => {
            if (value.value) {
                props.submit(value.value);
                editMode.value = false;
            }
        };
        return {
            value,
            editMode,
            save,
        };
    },
});
export default SliceRename;
